export enum ApplicationStatus {
  NEW = 'new',
  IN_REVIEW = 'in_review',
  DECISION_MADE = 'decision_made',
}

export enum DecisionType {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export interface Applicant {
  id: string;
  name: string;
  email: string;
  profileImage?: string;
  creditScore: number;
  incomeRatio: number;
  housingVerified: boolean;
  identityVerified: boolean;
  incomeVerified: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Application {
  id: string;
  applicant: Applicant;
  listingId: string;
  status: ApplicationStatus;
  decision: DecisionType;
  appliedAt: Date;
  reviewedAt?: Date;
  decidedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface ApplicationFilters {
  listingId?: string;
  status?: ApplicationStatus;
  decision?: DecisionType;
}

export interface ApplicationCounts {
  new: number;
  inReview: number;
  decisionMade: number;
  total: number;
}

export interface ApplicationResponse {
  applications: Application[];
  counts: ApplicationCounts;
}
